// Components==============
import { faUpload } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import React, { useContext } from 'react';
import ChangeFormatSettings from './ChangeFormatSettings/ChangeFormatSettings';
import PortfolioShareCode from './PortfolioShareCode/PortfolioShareCode';
import './Right.module.scss';
import VisibilitySettings from './VisibilitySettings/VisibilitySettings';
import { MyPortfolioContext } from '../../MyPortfolio';
// =========================

export default function Right() {
  const { setExportModalOpen } = useContext(MyPortfolioContext);

  return (
    <>
      <div styleName="right-wrapper">
        <PortfolioShareCode />
        <VisibilitySettings />
        <ChangeFormatSettings />
        <Button onClick={() => setExportModalOpen(true)} color="blue">
          Export <FontAwesomeIcon color="white" icon={faUpload} />
        </Button>
      </div>
    </>
  );
}
